import { isValidQuery } from "components/hostedScrapingValidators";
import { SDEContent } from "./sdecontentTypes";

export const GoogleMapsSearchContent: SDEContent = {
  projectType: 'async_google_maps_search',
  projectCategory: 'google',
  apiUrlFn: (apiHost: string) => {
    return `${apiHost}/structured/google/mapssearch/v1`;
  },
  docsSection: 'google-maps-search-api',
  docsSectionTitle: 'Google Maps Search API',
  docsSectionAsync: 'google-maps-search-api-async',
  docsSectionAsyncTitle: 'Google Maps Search API (Async)',
  inputKey: 'query',
  inputsKey: 'queries',
  validatorFunction: isValidQuery,
  newProjectEditProject: {
    inputBoxLabels: {
      listLiteralInputTitle: 'Search terms',
      listLiteralInputPlaceholder: 'Enter one search term per line.',
    },
    inputSectionLabels: {
      inputSectionTitle: "Input search term",
      inputSectionDescription: "Enter search terms in the input field or upload CSV with your search terms to begin scraping Google Maps.",
    },
    projectContent: {
      title: 'Google Maps Search',
      description: 'Extract Google Maps search results such as business names, addresses, phone numbers, and reviews.',
      icon: 'google',
      inputTitle: 'Query',
    },
  },
  apiPlayground: {
    inputSectionLabels: {
      inputSectionTitle: 'Input search term',
      inputSectionDescription: 'Enter Google Maps search terms to begin scraping Google Maps.',
    },
    projectContent: {
      title: 'Google Maps Search',
      description: 'Extract Google Maps search results such as business names, addresses, phone numbers, and reviews.',
      icon: 'google',
    },
    enterInputsPlaceholder: 'query',
    enterInputsMessage: 'Enter keyword for scraping',
    codeViewPlaceHolder: 'Please provide a valid search term',
    dropdownTitle: 'Google Maps Search'
  }
};
